import { render, staticRenderFns } from "./RefundListFiltersHeader.vue?vue&type=template&id=56d6b334&"
import script from "./RefundListFiltersHeader.vue?vue&type=script&lang=js&"
export * from "./RefundListFiltersHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CBox: require('@chakra-ui/vue').CBox, CPopoverTrigger: require('@chakra-ui/vue').CPopoverTrigger, CPopoverArrow: require('@chakra-ui/vue').CPopoverArrow, CPopoverCloseButton: require('@chakra-ui/vue').CPopoverCloseButton, CPopoverBody: require('@chakra-ui/vue').CPopoverBody, CPopoverContent: require('@chakra-ui/vue').CPopoverContent, CPopover: require('@chakra-ui/vue').CPopover, CFlex: require('@chakra-ui/vue').CFlex})
